import axios from "axios";
import VueCookies from "vue-cookies";
import toast from "vue3-toastify";

const state = {
    wallet:{},
};

const getters = {
    getWalletData(state){
        return state.wallet;
    }
};

const mutations = {
    setWalletData(state, data){
        state.wallet= data
    }
};

const actions = {
    getWalletDataFromApi({dispatch, commit}){
        return axios.get("https://api.moallem.sch.ir/wallet/v1/detail/",
        {
            headers: {
                Authorization: VueCookies.get("TOKEN-TYPE") +" "+ VueCookies.get("ACCESS-TOKEN"),
            },
        }).then((response) => {
            commit("setWalletData", response.data);
        }).catch((error) => {
            if (error.response.status == 401) {
                dispatch("getAccessTokenFromRefreshToken").then((response) => {
                    if (response) dispatch("getWalletDataFromApi");
                });
            } else {
                toast.error("اطلاعات کیف پول دریافت نشد لطفا بعدا تلاش کنید")
            }
            console.error(error);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}